import { FormatLabelFn } from '@@partner:types:app'

import {
  STATUS_PAYMENT_PENDING,
  STATUS_PAYMENT_SUCCESS,
  STATUS_PAYMENT_WAITING_FOR_CAPTURE,
  STATUS_PAYMENT_CANCELED,
  PAYMENT_OPERATION_TYPE_PAYMENT,
  PAYMENT_OPERATION_TYPE_REFUND,
  STATUS_PAYMENT_RESERVED
} from '@@partner:config/order-payment-status-codes'

import {
  PAYMENT_TYPE_BONUSES,
  PAYMENT_TYPE_CASH,
  PAYMENT_TYPE_YANDEX,
  PAYMENT_TYPE_SOCIAL
} from '@@partner:config/payment-types'
import { PAYMENT } from '@hive/status'

/*
  Get order payments info
*/

export const formatOrderPaymentType: FormatLabelFn<string> = (
  value: string
) => {
  switch (value) {
  case PAYMENT_TYPE_YANDEX:
    return { label: 'Карта (yandex)' }
  case PAYMENT_TYPE_CASH:
    return { label: 'Наличные' }
  case PAYMENT_TYPE_BONUSES:
    return { label: 'Бонусы' }
  case PAYMENT_TYPE_SOCIAL:
    return { label: 'Социальный заказ' }
  default:
    return { label: `Неизвестный способ (${value})`, color: 'red' }
  }
}

/*
  Get order payments info
*/

export const formatOrderPaymentOperation: FormatLabelFn<string> = (
  value: string
) => {
  switch (value) {
  case PAYMENT_OPERATION_TYPE_PAYMENT:
    return { label: 'Оплата', color: 'green' }
  case PAYMENT_OPERATION_TYPE_REFUND:
    return { label: 'Возврат', color: 'red' }
  default:
    return { label: `Неизвестная операция (${value})`, color: 'red' }
  }
}

export const formatOrderPaymentStatus: FormatLabelFn<string> = (value) => {
  switch (value) {
  case PAYMENT.PENDING:
    return { label: 'В процессе', color: 'blue' }
  case PAYMENT.COMPLETE:
    return { label: 'Успешно', color: 'green' }
  case STATUS_PAYMENT_WAITING_FOR_CAPTURE:
    return { label: 'Ожидание подтверждения платежа', color: 'violet' }
  case PAYMENT.CANCEL:
    return { label: 'Отмена', color: 'red' }
  case PAYMENT.INITIAL:
  case PAYMENT.RESERVED:
    return { label: 'Создан', color: undefined }
  case PAYMENT.EXTERNAL_ERROR:
    return { label: 'Ошибка внешней системы', color: 'red' }
  case PAYMENT.CANCEL:
    return { label: 'Отменен', color: 'red' }
  default:
    return { label: `Неизвестный статус платежа (${value})`, color: 'red' }
  }
}
